import { Stack as MuiStack, StackProps as MuiStackProps } from '@mui/material';
import { Ref, forwardRef } from 'react';

export const Stack = forwardRef(({ ...rest }: MuiStackProps, ref: Ref<HTMLDivElement>) => (
  <MuiStack ref={ref} {...rest} />
));
